<template>
  <div class="date-picker uk-flex">
    <div class="uk-width-1-4 uk-margin-right">
      <select
        name="month"
        class="uk-select"
        v-model="month"
        @change="onChangeMonth"
      >
        <option value="">Month</option>
        <option v-for="month in months" :key="month" :value="month">{{
          month + 1
        }}</option>
      </select>
    </div>
    <div class="uk-width-1-4 uk-margin-right">
      <select class="uk-select" v-model="day" @change="onChangeDay">
        <option value="">Day</option>
        <option v-for="day in days" :value="day" :key="day">{{ day }}</option>
      </select>
    </div>
    <div class="uk-width-1-2">
      <select
        name="year"
        class="uk-select"
        v-model="year"
        @change="onChangeYear"
      >
        <option value="">Year</option>
        <option v-for="year in years" :key="year" :value="year">{{
          year
        }}</option>
      </select>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    format: {
      type: String,
      default: "YYYYMMDD"
    }
  },
  data: function() {
    return {
      year: "",
      month: "",
      day: "",
      years: [],
      months: [],
      days: []
    };
  },
  computed: {
    date: {
      get: function() {
        return moment({
          year: this.year,
          month: this.month,
          day: this.day
        });
      },
      set: function(v) {
        var _d = null;
        if (moment.isMoment(v)) {
          _d = v;
        } else {
          _d = moment(v, this.format);
        }
        if (!_d.isValid()) {
          throw new Error(
            "Not valid moment or not valid time for format: ",
            this.format
          );
        }
        this.year = _d.year();
        this.month = _d.month();
        this.day = _d.date();
      }
    }
  },
  created: function() {
    this.getYears();
    this.getMonths();
    this.getDays();
  },
  methods: {
    getYears: function() {
      var _to = new Date().getFullYear();
      for (var _y = _to; _y >= _to - 120; _y--) {
        this.years.push(_y);
      }
    },
    getMonths: function() {
      this.months = [];
      var _to = 11;
      var _m = 0;
      for (; _m <= _to; _m++) {
        this.months.push(_m);
      }
    },
    getDays: function() {
      this.days = [];
      var _to = moment(new Date(this.year, this.month, 1)).daysInMonth();
      var _d = 1;
      for (; _d <= _to; _d++) {
        this.days.push(_d);
      }

      if (this.month == 1 && this.days.length == 28) {
        // Feb
        this.days.push(29);
      }
    },
    onChangeYear: function() {
      this.emitDate();
    },
    onChangeMonth: function() {
      this.getDays();
      if (this.days.indexOf(this.day) == -1) {
        this.day = "";
      }
      this.emitDate();
    },
    onChangeDay: function() {
      this.emitDate();
    },
    emitDate: function() {
      if (this.month && this.day && this.year) {
        this.$emit("date-change", this.date.format("YYYY-MM-DD"));
      } else {
        this.$emit("date-change", "");
      }
    }
  }
};
</script>
